module.exports = __webpack_public_path__ + "img/vegetable-ginger-350x184.b77b697e.jpg";